import {
  ChatPage,
  ChatPageExploreSkeleton,
  ChatPageSkeleton,
} from "@pages/ChatPage";
import { AppRoute } from "./types";
import { RootChatEntry } from "./RootChatEntry";
import { NewChatEntry } from "./NewChatEntry";
import { sidekickModuleEnum } from "@shared/access-control/sidekick-modules";
import { CenteredLoadingSpinner } from "@shared/components/CenteredLoadingSpinner";

export const chatRoutes: AppRoute[] = [
  {
    path: "/new",
    element: <NewChatEntry />,
    protected: true,
    fallback: <CenteredLoadingSpinner />,
  },
  {
    path: "/explore",
    element: <ChatPage view="explore" />,
    protected: true,
    fallback: <ChatPageExploreSkeleton />,
    requiredModule: sidekickModuleEnum.MLS_ACCESS,
  },
  {
    path: "/",
    element: <RootChatEntry />,
    protected: true,
    fallback: <CenteredLoadingSpinner />,
  },
  {
    path: "/chat/:threadId",
    element: <ChatPage />,
    protected: true,
    fallback: <ChatPageSkeleton />,
  },
];
